import React, { memo } from "react";
import { MessageFragment } from "gql/graphql";
import { MessageSubType } from "modules/utils/Constants";
import ReactPlayer from "react-player";

interface IProps {
  message: MessageFragment;
}

const WelcomeVideo = ({ message }: IProps) => {
  if (message.subType !== MessageSubType.WELCOME) {
    return null;
  }

  return (
    <ReactPlayer
      playing
      controls
      url="https://support.teamsynco.com/hubfs/Getting%20Started%20with%20synco%20v2.mp4"
      width="100%"
      height="100%"
      config={{
        file: {
          attributes: {
            style: {
              width: "100%",
              height: "100%",
              objectFit: "contain",
            },
          },
        },
      }}
    />
  );
};

export default memo(WelcomeVideo);
